<template>
    <el-card class="box-card" :body-style="{'padding' : '0'}">
        <div slot="header" class="clearfix">
            <classify-search :searchQuery="searchQuery" @changeInput="changeInput"/>
        </div>
        <el-menu :default-active="active" class="el-menu-vertical">
            <el-menu-item index="1" @click="clickItem('1')">
                <i class="el-icon-menu"></i>
                <span slot="title">器件展示</span>
                <span class="el-icon-caret-right classify-right-icon"></span>
            </el-menu-item>
            <el-menu-item index="2" @click="clickItem('2')">
                <i class="el-icon-document"></i>
                <span slot="title">标准解析</span>
                <span class="el-icon-caret-right classify-right-icon"></span>
            </el-menu-item>
            <el-menu-item index="3" @click="clickItem('3')">
                <i class="el-icon-setting"></i>
                <span slot="title">通用规范</span>
                <span class="el-icon-caret-right classify-right-icon"></span>
            </el-menu-item>
        </el-menu>
    </el-card>
</template>
<script>
import classifySearch from "./classifySearch.vue";

export default {
    props: ['active', 'searchQuery'],
    methods: {
        changeInput(val) {
            this.$emit('changeInput', val);
        },
        clickItem(index) {
            this.$emit('clickItem', index);
        }
    },
    components: {classifySearch}
}
</script>

<style lang="scss" scoped>
    .box-card {
        position: fixed; 
        right: 50px; 
        top: 120px;
        width: 25vh;

        .el-card__header {
            padding: 10px 20px !important;
        }

        .classify-right-icon {
            float: right; 
            line-height: 56px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/views/classify/classifyRightMenu.vue